/*
 *   File : custom-select.js
 *   Author : https://evoqins.com
 *   Description : Custom select component
 *   Integrations : react-select
 *   Version : 1.0.0
*/

import React, { memo } from 'react';
import Select from 'react-select';

const CustomSelectBox = (props) => {

    // handle select value 
    const valueChange = (e) => {
        props.selectChange(e);
    };

    const CUSTOM_STYLE = {
        dropdownIndicator: (base, state) => ({
            ...base,
            transition: "all .2s ease",
            transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null
        }),
        control: (styles, state) => ({
            ...styles,
            borderColor: state.menuIsOpen ? '#213366' : props.borderColor ? props.borderColor : '#E3E5E5',
            boxShadow: state.menuIsOpen ? '#213366' : 'none',
            '&:hover': {
                borderColor: '#213366',
            },
            borderRadius: props.type === 1 ? "0.75rem" : props.type === 2 ? "0.25rem" : "0.5rem",
            cursor: "pointer",
            background: "transparent",
            fontSize: props.fontSize ?? "14px",
            width: props.width ? props.width : "",
            height: props.height ? props.height : "",
            minHeight: props.minHeight ?? ""
        }),
        singleValue: (styles) => ({
            ...styles,
            fontSize: props.fontSize ?? "14px",
            fontWeight: props.fontWeight ?? 600,
            lineHeight: "24px",
            color: "#212121",
            fontFamily: "Noto Sans"
        }),

        indicatorContainer: (base) => ({
            ...base,
            padding: 0,
        }),
        dropdownIndicator: (base, state) => ({
            ...base,
            padding: "0 4px",
            transition: "all .2s ease",
            transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
        }),
        menu: (base) => {
            // Portaled + fixed menus: % minWidth and right:0 resolve against the viewport, not the
            // control, which stretches the menu across the screen in production.
            if (props.menuPortalTarget) {
                return {
                    ...base,
                    ...(props.menuWidth ? { width: props.menuWidth } : {}),
                };
            }
            return {
                ...base,
                ...(props.menuWidth ? { width: props.menuWidth } : {}),
                minWidth: "100%",
                right: 0,
            };
        },
        menuList: (styles) => ({
            ...styles,
            maxHeight: '180px',
            overflowX: "none",
            width: "100%",
            '&::-webkit-scrollbar-thumb': {
                background: "#213366",
                borderRadius: "0.25rem",
            },

            '&::-webkit-scrollbar': {
                width: "0.125rem",
                height: "0.125rem",
                display: "block",
            }
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),

        multiValue: (defaultStyles) => ({
            ...defaultStyles,
            backgroundColor: "transparent",
            minWidth: "max-content",
            borderRadius: "1.5rem",
            border: "1px solid #213366",
            padding: "3px 0.5rem",
            margin: "0 0.5rem 0 0",
            display: "flex",
            gap: "0.25rem",
            alignItems: "center",

        }),
        multiValueLabel: (defaultStyles) => ({
            ...defaultStyles,
            color: "#151515",
            fontSize: props.fontSize ?? "0.75rem",
            fontWeight: "400",
            lineHeight: "1rem",
            margin: "0",
            padding: "0",
        }),
        multiValueRemove: (defaultStyles) => ({
            ...defaultStyles,
            color: "#000000",
            cursor: "pointer",
            padding: "0",
            "&:hover": {
                color: "#000000",
                backgroundColor: "transparent",
            },
        }),

        valueContainer: (defaultStyles) => ({
            ...defaultStyles,
            padding: props.padding ? props.padding : "8px 14px",
            margin: "0px",
            ...(props.isMulti === true && {
                display: "flex",
                flexWrap: "nowrap",
                overflowX: "auto",
                maxWidth: "100%",
                scrollbarWidth: "none", // Firefox
                "&::-webkit-scrollbar": {
                    display: "none", // Chrome, Safari, Edge
                },
            })
        }),
    };

    return (
        <div>
            {props.label &&
                <label className={`${props.labelClass} padding-6px-bottom e-text-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-18px d-flex`}>
                    {props.label}
                    {!props.optional && <span className='e-text-lust'>*</span>}
                </label>
            }
            <div className={props.type === 1 ? '' : props.wrapperHeight ?? 'h-64px'}>
                <Select isSearchable={props.isSearchable}
                    isClearable={props.isClearable}
                    className={`e-select-box ${props.className}`}
                    isDisabled={props.isDisabled}
                    options={props.options}
                    value={props.value ? props.value : ""}
                    isMulti={props.isMulti}
                    placeholder={props.placeholder}
                    defaultValue={props.defaultValue}
                    menuIsOpen={props.menuIsOpen}
                    styles={CUSTOM_STYLE}

                    menuPortalTarget={props.menuPortalTarget}
                    menuPosition={props.menuPosition}
                    onMenuOpen={props.onMenuOpen}
                    onMenuClose={props.onMenuClose}
                    onChange={(e) => { valueChange(e) }}

                    {...props} />

                {props.error &&
                    <p className='mb-0 e-error-message e-alt-font-noto-sans e-font-12 line-height-12px pt-1'>
                        {props.error}
                    </p>
                }
            </div>
        </div>
    )
}

export default memo(CustomSelectBox);